
(function($) {
	$(document).ready(function() {



		var element = $('.grid-item-container');

		if( element.length > 0){
			var shuffleInstance = new Shuffle(element, {
				itemSelector: '.project-item',
				sizer: '.project-item',
				buffer: 0,
			});

			function get(name){
			   if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
			      return decodeURIComponent(name[1]);
			}

			function set_eqheight(){
				//Requires jquery matchHeight			
				$('.project-item').matchHeight({
					byRow: false,
					property: 'height',
					target: null,
					remove: false
				});
				console.log('matchHeight set');
			}

			$(window).on("load", function () {
				set_eqheight();

			})
			$(window).on("resize", function () {
				set_eqheight();
			})

			let slug = $('#filterbar').data('filter-slug');
			// Bind to the load event of the window object
			$(window).on("load", function () {
				shuffleInstance.filter( slug );
				$('.filter-picker a').removeClass('active');
				// $(this).addClass('active');
				// console.log( slug );
			})


			
			$('.filter-tags a').on('click', function(event){
				event.preventDefault();
				shuffleInstance.filter($(this).data('filter'));
				$('.filter-tags a').removeClass('active');
				$(this).addClass('active');
				let title = $(this).text();
				if( title == "Show All" ){
					title = "All"
				}
				$('#filterbar .title').text('Showing '+ title +' Projects');
			});
		}





    }); //end docready
})(jQuery);